import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { HandymanAppState } from '../../../../configuration/redux/reducers';
import { getUserReviews } from '../../../Reviews/actions';
import ReviewsList from '../../../../components/Reviews/ReviewsList';
import RatingSummary from '../../../../components/Reviews/RatingSummary';

interface UserReviewsProps {
  userId?: string;
}

const UserReviews: React.FC<UserReviewsProps> = ({ userId }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const {
    userReviews,
    userReviewsLoading,
    userReviewsError,
    userReviewsTotalCount,
  } = useSelector((state: HandymanAppState) => state.review);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (userId) {
      dispatch(getUserReviews(userId, currentPage) as any);
    }
  }, [dispatch, userId, currentPage]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <Box sx={{ position: 'relative' }}>
      {/* Title */}
      <Box
        sx={{
          position: 'absolute',
          left: '24px',
          top: '0px',
          fontFamily: 'Montserrat',
          fontStyle: 'normal',
          fontWeight: 700,
          fontSize: '24px',
          lineHeight: '133.4%',
          color: isDark ? '#00FFFF' : '#005CAD',
        }}
      >
        Reviews
      </Box>

      {/* View All Reviews Link */}
      <Box
        sx={{
          position: 'absolute',
          right: '24px',
          top: '0px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
          padding: '0px',
          gap: '10px',
        }}
      >
        <Link
          to={`/reviews/user/${userId}`}
          style={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '157%',
            letterSpacing: '0.1px',
            color: isDark ? '#B6B6B6' : '#1A1A1A',
            textDecoration: 'none',
          }}
        >
          View all reviews
        </Link>
      </Box>

      {/* Content Grid */}
      <Grid container spacing={3} sx={{ mt: '56px' }}>
        <Grid item xs={12} md={4}>
          <RatingSummary
            reviews={userReviews}
            loading={userReviewsLoading}
            totalCount={userReviewsTotalCount}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <ReviewsList
            reviews={userReviews.slice(0, 2)} // Show only first 2 reviews
            loading={userReviewsLoading}
            error={userReviewsError}
            totalCount={userReviewsTotalCount}
            onPageChange={handlePageChange}
            showActions={false}
            emptyMessage='No reviews yet'
            title=''
            currentPage={currentPage}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserReviews;
